function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 42,
  rx: 5,
  fill: "#363537"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M-382.128-258.61h-7.2v-1.543h2.829v-3.857h1.543v3.857h2.829Zm4.924-6.943h-17.049V-267.1h1.35l.331-3.8a2.3,2.3,0,0,1,1.958-2.088V-274.3a1.8,1.8,0,0,1,1.8-1.8h1.286a.514.514,0,0,1,.514-.514h2.057a.514.514,0,0,1,.514.514v1.543a.514.514,0,0,1-.514.514h-2.057a.514.514,0,0,1-.514-.514h-1.286a.257.257,0,0,0-.257.257v1.286h7.881a2.3,2.3,0,0,1,2.306,2.114l.33,3.8h1.35v1.543Z",
  transform: "translate(400.252 294.61)",
  fill: "#fff"
});

var SvgKeynoteIcon = function SvgKeynoteIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 42,
    viewBox: "0 0 34 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKeynoteIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/keynote_icon.ae8684e5.svg";
export { ForwardRef as ReactComponent };